module.exports = __webpack_public_path__ + "92ca3cd514840498d40d0eb0b6baafa5.png";